module.exports = __webpack_public_path__ + "img/bg-showcase-1.dbfff7f3.jpg";